<template>
    <div class="leftbar">
            <el-menu
            :default-active="activemenu"
            style="border-right:none;"
            class="el-menu-vertical-demo"
            router
            @open="handleOpen"
            @close="handleClose"
            background-color="#545c64"
            text-color="#fff"
            :collapse="changmenu"
            active-text-color="#ffd04b">
                <template v-for="(item,index) in menuList" >
                    <el-submenu :index=index.toString() :key="index">
                        <template slot="title">
                            <i v-if="item.meta.icon!=''" :class="item.meta.icon"></i>
                            <span :title="item.name">{{item.name}}</span>
                        </template>
                        <el-menu-item v-for="(sonitem,sonindex) in item.children" :index="sonitem.component" :key="sonindex">
                            <span :title="sonitem.meta.title">{{sonitem.meta.title}}</span>
                        </el-menu-item>
                    </el-submenu>
                </template>
            </el-menu>
    </div>
</template>
<script>
import apiurl from "@/api/sys"
import _api from "@/api/index"
export default {
    data(){
        return{
            url:"/rolePer/getPermission",
            isCollapse:false,
            menuList:[],
            minimumMoney:0,
            minimumAudit:0,
            rulesList:[],
            activemenu:"/home"
        }
    },
    props:{
        changmenu:{
            type:Boolean,
            default:false
        },
        logourl:{
            type:String
        },
        activePath: {
            type: String,
            default: ''
        }
    },

    computed:{
        menuRefreshFlag(){
            return this.$store.state.menuRefreshFlag
        }
    },

    created(){
        this.menuList=JSON.parse(localStorage.getItem("menu"))
        this.loadMenu()
        this.getNum()
    },

    methods:{
        handleOpen(){},
        handleClose(){},
        getNum(){
            _api.get(apiurl.audits,{}).then(res=>{
                if(res.code==200){
                    this.minimumAudit=res.data.minimumAudit
                    this.minimumMoney=res.data.minimumMoney
                }
            })
        },
        loadMenu(){
            this.menuList = JSON.parse(localStorage.getItem("menu") || "[]")
        }
    },
    watch:{
        menuRefreshFlag(){
            this.loadMenu()
        },
        $route(to,from){
            this.activemenu=to.path
            if(to.path!="/error/500"){
                this.getNum()
            }
        }
    }
}
</script>
<style>
.el-badge__content{border:none!important;}
.el-badge__content.is-fixed{top: 11px!important;right: 3px!important;}
</style>
<style scoped>
.leftbar{ background: #0f080f; height: 100%;}
</style>
